/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class ClaimNew extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            dt: null
        }
    }

    async componentDidMount() {
        try {
            let j = await qreq.getAsync('/api/claim/possible/visit/list');
            if (j.list) {
                j.list.forEach(i => {
                    i.patientName = i.patient.firstName + ' ' + i.patient.lastName;
                    i.scheduleDateDT = new Date(i.scheduleDate);
                });
                this.setState({ list: j.list, sourceList: j.list });
            }
            else if (j.errorCode)
                this.alert(j.errorMesage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    submit = async (e) => {
        e.preventDefault();
        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/claim/create', {
                visits: this.state.list.filter(v => v.selected)
            });
            if (j.errorCode === 0)
                this.props.navigate('/claim/list');
            else if (j.errorCode)
                this.alert(j.errorMesage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
        this.setState({ submitting: false });
    }

    toggleVisit = (e, visit) => {
        visit.selected = e.target.checked;
        this.setState({ list: this.state.list });
    }

    toggleAllVisits = (e) => {
        this.state.list.forEach(v => v.selected = e.target.checked);
        this.setState({ list: this.state.list });
    }

    sort = (field) => {
        let desc = this.state.sortDesc;
        let list = [...this.state.list];
        list.sort((a, b) => {
            if (a[field] < b[field]) return -1;
            if (a[field] > b[field]) return 1;
            return 0;
        });
        if (desc)
            list.reverse();
        this.setState({ list: list, sortDesc: !desc });
    }


    search = (e) => {
        let val = e.target.value;
        if (val) {
            let list = this.state.sourceList.filter(v => v.patientName.toLowerCase().includes(val.toLowerCase()));
            this.setState({ list: list });
        }
        else
            this.setState({ list: this.state.sourceList });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>Generate Claims</h1>
                <div className="mb-3">
                    <input type="text" className="form-control" placeholder="Search" onChange={this.search} />
                </div>
                <form onSubmit={this.submit}>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th style={{ widht: '25px' }}><input type="checkbox" checked={this.state.list?.every(v => v.selected)} onChange={this.toggleAllVisits} /></th>
                                <th><span role="button" onClick={() => this.sort('scheduleDateDT')}>Visit Date</span></th>
                                <th><span role="button" onClick={() => this.sort('patientName')}>Patient</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.list?.map((visit, idx) => <tr key={idx}>
                                <td><input type="checkbox" checked={visit.selected} onChange={(e) => this.toggleVisit(e, visit)} /></td>
                                <td><Link to={`/visit/view/${visit.id}`}>{Globals.toMDYLocalDateString(visit.scheduleDate)}</Link></td>
                                <td>
                                    <Link to={`/order/view/${visit.orderID}`}>
                                        {visit.patient.firstName}
                                        {' '}{visit.patient.lastName}
                                        {' '}<span className="text-muted">{visit.patient.birthDate}</span>
                                    </Link>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                    <AppActions>
                        <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}><Icon icon="faSave" /> Create</button>
                    </AppActions>
                </form>
            </div>
        );
    }
}

export default withParamsAndNavigate(ClaimNew);